<div class="flex flex-col items-center w-full max-w-xl mx-auto py-1">
  <!-- Top line: Title & Details link -->
  <div class="flex items-center justify-center gap-2 text-sm font-semibold text-gray-11 mb-1">
    <span>Prix moyen au m²</span>
    <span class="text-gray-7">|</span>
    <a
      href="https://app.dvf.etalab.gouv.fr/"
      target="_blank"
      rel="noopener noreferrer"
      class="inline-flex items-center gap-0.5 text-indigo-11 hover:underline underline-offset-2 cursor-pointer font-medium text-xs"
      [matTooltip]="detailsTooltip()"
      matTooltipPosition="above"
    >
      + de détails
    </a>
  </div>

  <!-- Big central price number -->
  <div class="text-3xl sm:text-3xl font-black text-gray-12 tracking-tight my-0.5 flex items-baseline gap-1">
    <span>{{ medianPriceM2() | number: '1.0-0' : 'fr-FR' }}</span>
    <span class="text-xl sm:text-2xl font-bold text-gray-11">€</span>
  </div>

  <!-- Subtitle badge comparing current property to median -->
  @if (currentPriceM2(); as current) {
    <div class="mb-2">
      <span
        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full  font-bold border {{
          comparisonBadge()?.colorClass
        }}"
      >
        Ce bien : {{ current | number: '1.0-0' : 'fr-FR' }} €/m² ({{ comparisonBadge()?.text }})
      </span>
    </div>
  }

  <!-- Gauge bar container -->
  <div class="w-full relative px-1 my-2">
    <!-- Gradient track from green to red -->
    <div
      class="w-full h-2.5 rounded-full shadow-inner"
      style="
        background: linear-gradient(
          to right,
          #10b981 0%,
          #84cc16 28%,
          #eab308 50%,
          #f97316 75%,
          #ef4444 100%
        );
      "
    ></div>

    <!-- Notch marker for sector median -->
    <div
      class="absolute top-1/2 -translate-y-1/2 w-0.5 h-4 bg-gray-12/60 rounded-full pointer-events-none"
      [style.left.%]="medianPositionPercent()"
      [matTooltip]="'Prix médian du secteur : ' + (medianPriceM2() | number: '1.0-0' : 'fr-FR') + ' €/m²'"
      matTooltipPosition="above"
    ></div>

    <!-- Cursor indicator for the current property -->
    @if (currentPriceM2()) {
      <div
        class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 z-10 cursor-pointer group"
        [style.left.%]="currentPositionPercent()"
        [matTooltip]="cursorTooltip()"
        matTooltipPosition="above"
      >
        <!-- Pill handle matching the reference image -->
        <div
          class="h-4 w-7 rounded-full shadow-md border-2 border-white ring-2 transition-transform group-hover:scale-110 flex items-center justify-center {{
            comparisonBadge()?.cursorColorClass || 'bg-amber-400 ring-amber-200'
          }}"
        >
          <div class="w-1 h-2 bg-white/80 rounded-full"></div>
        </div>
      </div>
    }
  </div>

  <!-- Bottom scale labels: Prix bas & Prix haut -->
  <div class="w-full flex justify-between items-center text-xs text-gray-11 font-medium mt-0.5">
    <span>
      Prix bas :
      <strong class="text-gray-12 font-bold">{{ effectiveMin() | number: '1.0-0' : 'fr-FR' }} €</strong>
    </span>
    <span>
      Prix haut :
      <strong class="text-gray-12 font-bold">{{ effectiveMax() | number: '1.0-0' : 'fr-FR' }} €</strong>
    </span>
  </div>
</div>
